import React, { useEffect, useState } from "react";
import { Card, Badge, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import {
  DataTableHead,
  DataTableRow,
  DataTableItem,
  UserAvatar,
  PaginationComponent,
  DataTable,
  Button,
  Icon,
  DataTableBody,
  PreviewAltCard,
} from "../../../components/Component";
// import { recentOrderData } from "./OrderData";
import { BASE_URL_IMG, RUPEES_SYMBOL } from "../../../assets/constants";
import MyLoader from "../../../MyComp/UI/form/MyLoader";
import CancelOrderModal from "../../../MyComp/UI/modals/CancelOrderModal";
import { UserAvatarCell } from "../../../MyComp/ImageView/UserAvatarCell";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { updateSampleStatusAPI } from "../../../api/pahrmacy";
import { toast } from "react-toastify";
import { labOrderListAPI } from "../../../api/pahrmacy";
import AssignOrderModal from "../../../components/partials/default/recent-orders/AssignmentModal";
import { getLabBoyList, assignSampleCollection, uploadLabReportAPI } from "../../../api/master/indes";
import { useNavigate } from "react-router-dom";

const LabOrderData = ({
  data,
  isLoading,
  paginate,
  currentPage,
  itemPerPage,
  getOrders,
  limit,
  setonSearch,
  onSearch,
  setSearchText,
  onSearchText,
  setItemPerPage,
  onOrderClick,
  toggleCancelOrder,
  noPagination,
  title,
  updateOrderStatus,
  isOpen,
  selectedRow,
  setIsOpen,
  setSelectedRow,
  updateSampleStatus,
  handleSampleStatusUpdate,
  handleAssignOrderUpdate,
}) => {
  // onChange function for searching name
  const onFilterChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const truncateByWords = (text = "", wordLimit = 5) => {
    if (!text) return "";

    const words = text.trim().split(/\s+/);
    return words.length > wordLimit ? words.slice(0, wordLimit).join(" ") + " ..." : text;
  };
  const [assignModal, setAssignModal] = useState(false);

  const assignOrder = (data) => {
    setAssignModal(true);
    setSelectedRow(data);
  };

  const handleAssignModalClose = () => {
    setAssignModal(false);
    setSelectedRow(null);
  };

  const navigate = useNavigate();

  const [availableUsers, setAvailableUser] = useState([
    // { id: 1, name: "John Doe", email: "john@example.com", role: "Delivery Agent" },
    // { id: 2, name: "Jane Smith", email: "jane@example.com", role: "Delivery Agent" },
    // { id: 3, name: "Mike Johnson", email: "mike@example.com", role: "Delivery Agent" },
    // { id: 4, name: "Sarah Wilson", email: "sarah@example.com", role: "Manager" },
    // { id: 5, name: "Robert Brown", email: "robert@example.com", role: "Delivery Agent" },
  ]);
  const [localData, setLocalData] = useState(data || []);

  useEffect(() => {
    labBoyListAPI();
  }, []);

  const labBoyListAPI = () => {
    const body = {
      limit: 10,
      page: 1,
    };

    getLabBoyList(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.data.message);
          // console.log(res.data.data.labBoyList,"labBoyList")
          toast.clearWaitingQueue();

          setAvailableUser(res.data.data.labBoyList);
          // setValue("categoryDD", res.data.data);
          // setValue("isLoading", false);
        } else if (res.data.status === false) {
          // setValue("isLoading", false);
          // setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          // setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          // logout();
        }
      })
      .catch((err) => {
        // setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
    // Here you would make an API call to assign the order
    // console.log("Assigning order:", order, "to user ID:", id);

    // Find the selected user
    // const selectedUser = availableUsers.find((user) => user.id === id);
    // console.log("Selected user:", selectedUser);

    // You can call a prop function to handle the assignment
    // onAssignOrder(order, userId);

    // Show success message or handle accordingly
    // alert(`Order #${order.orderNum} assigned to ${selectedUser?.name}`);
  };
  const updateOrder = (data) => {
    setIsOpen(true);
    setSelectedRow(data);
  };
  const userId = localStorage.getItem("userId");

  const [uploadedReports, setUploadedReports] = useState({});

  useEffect(() => {
    setLocalData(data || []);
  }, [data]);

  // const normalizeLabReportUrl = (report) => {
  //   if (!report) return null;
  //   if (typeof report === "string") return report;
  //   return report.file || report.url || report.report || null;
  // };

  const normalizeLabReportUrl = (url) => {
    if (!url) return null;

    // already full URL
    if (url.startsWith("http")) return url;

    // fallback base URL
    return `${process.env.REACT_APP_BASE_URL}/${url}`;
  };

  const getRowKey = (item) => `${item?.id ?? item?.orderNum ?? ""}`;

  const getLabReportUrl = (item) => {
    const key = getRowKey(item);

    // ✅ First check local uploaded state
    if (uploadedReports[key]) {
      return uploadedReports[key];
    }

    // ✅ Extract correct URL from API response
    const apiUrl = item?.labReport?.report_url || item?.lab_report?.report_url || item?.document || item?.report;

    return normalizeLabReportUrl(apiUrl);
  };

  // Upload report states
  const [uploadModal, setUploadModal] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const openUploadModal = (item) => {
    setSelectedRow(item);
    setUploadFile(null);
    setUploadModal(true);
  };

  const handleFileChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;

    const allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/jpg", "image/webp"];

    const allowedExtensions = ["pdf", "jpg", "jpeg", "png", "webp"];

    const fileType = file.type;
    const fileExtension = file.name.split(".").pop().toLowerCase();

    // ❌ Reject if BOTH are invalid
    if (!allowedTypes.includes(fileType) || !allowedExtensions.includes(fileExtension)) {
      toast.error("Only PDF and Image files are allowed");
      e.target.value = null;
      setUploadFile(null);
      return;
    }

    setUploadFile(file);
  };

  const handleUploadReport = async () => {
    if (!selectedRow) return toast.error("No order selected");
    if (!uploadFile) return toast.error("Please choose a file to upload");
    try {
      setUploading(true);
      const form = new FormData();
      form.append("labOrderId", selectedRow?.id || selectedRow?.orderNum || "");
      form.append("userId", userId || "");
      form.append("file", uploadFile);

      const res = await uploadLabReportAPI(form);
      if (res?.data?.status) {
        toast.success(res.data.message || "Report uploaded");
        const reportData = res?.data?.data?.labReport || res?.data?.labReport || null;
        const reportUrl = normalizeLabReportUrl(reportData);
        if (reportUrl) {
          setUploadedReports((prev) => ({
            ...prev,
            [getRowKey(selectedRow)]: reportUrl,
          }));
          setSelectedRow((prev) =>
            prev ? { ...prev, document: reportUrl, labReport: reportUrl, report: reportUrl } : prev,
          );
        }
        setUploadModal(false);
        const body = {
          page: currentPage,
          limit: itemPerPage,
        };

        try {
          const listRes = await labOrderListAPI(body);

          if (listRes?.data?.status) {
            const refreshedOrders =
              listRes.data?.data?.orders ||
              listRes.data?.data?.orderData?.orders ||
              listRes.data?.data?.orderData ||
              listRes.data?.data ||
              [];
            if (Array.isArray(refreshedOrders)) {
              setLocalData(refreshedOrders);
            }
            if (typeof getOrders === "function") {
              getOrders(body);
            }
          }
        } catch (err) {
          console.error("Refresh API failed", err);
        }
      } else {
        toast.error(res?.data?.message || "Upload failed");
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Upload error");
    } finally {
      setUploading(false);
    }
  };
  const userRole = localStorage.getItem("role");
  // or from API: user.role

  const handleUploadDocument = (item) => {
    console.log("Upload document for:", item);

    // Example navigation
    navigate("/upload-document", {
      state: { orderId: item?.id, data: item },
    });

    // OR open modal
  };

  return (
    <>
      <DataTable className={"card-stretch"}>
        <div className="card-inner">
          <div className="card-title-group">
            <div className="card-title">
              <h5 className="title">{title}</h5>
            </div>
            <div className="card-tools me-n1">
              <ul className="btn-toolbar gx-1">
                <li>
                  <Button
                    href="#search"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setonSearch(true);
                    }}
                    className="btn-icon search-toggle toggle-search"
                  >
                    <Icon name="search"></Icon>
                  </Button>
                </li>
                <li className="btn-toolbar-sep"></li>
                <li>
                  <UncontrolledDropdown>
                    <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                      <Icon name="setting"></Icon>
                    </DropdownToggle>
                    <DropdownMenu end className="dropdown-menu-xs">
                      <ul className="link-check">
                        <li>
                          <span>Show</span>
                        </li>
                        {[10, 20, 30, 50, 100].map((num) => (
                          <li key={num}>
                            <DropdownItem
                              className={`dropdown-item ${itemPerPage === num ? "active" : ""}`}
                              href="#dropdownitem"
                              onClick={() => setItemPerPage(num)}
                            >
                              {num}
                            </DropdownItem>
                          </li>
                        ))}
                      </ul>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li>
              </ul>
            </div>
            <div className={`card-search search-wrap ${onSearch && "active"}`}>
              <div className="search-content">
                <Button
                  onClick={() => {
                    setSearchText("");
                    setonSearch(false);
                  }}
                  className="search-back btn-icon toggle-search"
                >
                  <Icon name="arrow-left"></Icon>
                </Button>
                <input
                  type="text"
                  className="border-transparent form-focus-none form-control"
                  placeholder="Search..."
                  value={onSearchText}
                  onChange={(e) => onFilterChange(e)}
                />
                <Button className="search-submit btn-icon">
                  <Icon name="search"></Icon>
                </Button>
              </div>
            </div>
          </div>
        </div>
        <DataTableBody bodyclass="nk-tb-tnx">
          <DataTableHead className="nk-tb-item">
            <DataTableRow>
              <span className=" fw-bold">Order No.</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Patient Name</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Date</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Amount</span>
            </DataTableRow>
            <DataTableRow size={"md"}>
              <span className="fw-bold">Address</span>
            </DataTableRow>
            <DataTableRow size={"md"}>
              <span className="fw-bold">Purchased</span>
            </DataTableRow>
            {/* <DataTableRow size={"md"}>
              <span className="fw-bold">Product Category</span>
            </DataTableRow> */}
            <DataTableRow size={"md"}>
              <span className="fw-bold">Lab Name</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Sample Status</span>
            </DataTableRow>
            <DataTableRow>
              <span className="fw-bold">Delivery Boy Info</span>
            </DataTableRow>
            {toggleCancelOrder && userRole !== "admin" && userRole !== "telecaller" && (
              // !data?.some((item) => item?.productCategory?.toLowerCase() === "pathology") && (
              <DataTableRow>
                <span className="fw-bold">Action</span>
              </DataTableRow>
            )}

            {/* <DataTableRow>
              <span className="">Delivery Status</span>
            </DataTableRow> */}
          </DataTableHead>

          {isLoading ? (
            <MyLoader />
          ) : (
            <>
              {localData?.length > 0
                ? localData?.map((item, idx) => (
                    <DataTableItem key={idx}>
                      {onOrderClick ? (
                        <>
                          <DataTableRow>
                            <span className="tb-lead" onClick={() => onOrderClick(item)}>
                              <a href="#order" onClick={(ev) => ev.preventDefault()}>
                                {item.orderNum}
                              </a>
                            </span>
                          </DataTableRow>
                        </>
                      ) : (
                        <DataTableRow>
                          <span className="tb-lead">
                            <a href="#order" onClick={(ev) => ev.preventDefault()}>
                              {item.orderNum}
                            </a>
                          </span>
                        </DataTableRow>
                      )}

                      <DataTableRow>
                        <div className="user-card">
                          {/* <UserAvatar
                            className="sm"
                            theme={item?.theme}
                            text={item?.initial}
                            image={BASE_URL_IMG + item?.user?.image}
                          ></UserAvatar> */}
                          <UserAvatarCell
                            row={item?.user}
                            name={item?.user?.name}
                            image={`${BASE_URL_IMG + item?.user?.image}`}
                          />
                          <div className="user-name">
                            <span className="tb-lead">
                              {item?.user?.name} ({item?.user?.mobile})
                            </span>
                          </div>
                        </div>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="tb-sub">{item?.date}</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="tb-sub tb-amount">
                          {RUPEES_SYMBOL} {item?.totalAmount}
                        </span>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <span className="tb-sub">{truncateByWords(item?.address, 2)}</span>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <span className="tb-sub">{item?.purchased}</span>
                      </DataTableRow>
                      {/* <DataTableRow size="md">
                        <span className="tb-sub">{item?.productCategory}</span>
                      </DataTableRow> */}
                      <DataTableRow size="md">
                        <span className="tb-sub">
                          {item?.lab_name} <b>({item?.lab_mobile})</b>
                        </span>
                      </DataTableRow>
                      <DataTableRow>
                        <Badge
                          className="badge-dot badge-dot-xs text-capitalize"
                          color={
                            item?.status === "paid" || item?.status == "delivered"
                              ? "success"
                              : item?.status === "processing" ||
                                  item?.status == "shipped" ||
                                  item?.status == "out_for_delivery"
                                ? "warning"
                                : "danger"
                          }
                        >
                          {item?.sample_status}
                        </Badge>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <div className="tb-sub">
                          <div>
                            <strong>{item?.deliveryBoyInfo?.name}</strong>
                          </div>
                          <div>{item?.deliveryBoyInfo?.mobile}</div>
                        </div>
                      </DataTableRow>
                      {/* {toggleCancelOrder && item?.productCategory?.toLowerCase() !== "radiology" ? (
                        <div className="d-flex flex-wrap justify-content-center align-items-center my-5">
                          {userRole !== "admin" && userRole !== "telecaller" && item?.sample_status === "SCHEDULED" ? (
                            <Button
                              outline
                              color={`primary`}
                              size={`xs`}
                              className={`me-1`}
                              onClick={() => assignOrder(item)}
                            >
                              Assign
                            </Button>
                          ) : (
                            <>
                              <>
                                {userRole !== "admin" &&
                                  userRole !== "telecaller" &&
                                  item?.sample_status !== "COMPLETED" && (
                                    <Button
                                      outline
                                      color={`primary`}
                                      size={`xs`}
                                      className={`me-1`}
                                      onClick={() => updateOrder(item)}
                                    >
                                      Update
                                    </Button>
                                  )}
                              </>
                            </>
                          )}
                         
                        </div>
                      ) : (
                        <div></div>
                      )} */}
                      {toggleCancelOrder && item?.productCategory?.toLowerCase() !== "radiology" ? (
                        <div className="d-flex flex-wrap justify-content-center align-items-center my-5">
                          {/* ASSIGN BUTTON */}
                          {userRole !== "admin" && userRole !== "telecaller" && item?.sample_status === "SCHEDULED" ? (
                            <Button
                              outline
                              color="primary"
                              size="xs"
                              className="me-1"
                              onClick={() => assignOrder(item)}
                            >
                              Assign
                            </Button>
                          ) : (
                            <>
                              {/* UPDATE BUTTON */}
                              {userRole !== "admin" &&
                                userRole !== "telecaller" &&
                                item?.sample_status !== "COMPLETED" && (
                                  <Button
                                    outline
                                    color="primary"
                                    size="xs"
                                    className="me-1"
                                    onClick={() => updateOrder(item)}
                                  >
                                    Update
                                  </Button>
                                )}

                              {/* Upload Document button only if no report exists yet */}
                              {/* ✅ Show Upload Button ONLY when sample status is COMPLETED AND no document uploaded */}
                              {item?.sample_status?.toUpperCase() === "COMPLETED" && !getLabReportUrl(item) && (
                                <Button
                                  outline
                                  color="success"
                                  size="xs"
                                  className="me-1"
                                  onClick={() => openUploadModal(item)}
                                >
                                  Upload Document
                                </Button>
                              )}

                              {/* ✅ Show PDF Button ONLY when document exists */}
                              {item?.sample_status?.toUpperCase() === "COMPLETED" && getLabReportUrl(item) && (
                                <Button
                                  outline
                                  color="danger"
                                  size="xs"
                                  className="me-1"
                                  onClick={() => {
                                    const url = getLabReportUrl(item);
                                    if (url) window.open(url, "_blank");
                                  }}
                                >
                                  <Icon name="file-pdf" />
                                </Button>
                              )}
                            </>
                          )}
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </DataTableItem>
                  ))
                : null}
            </>
          )}
          <Modal isOpen={uploadModal} toggle={() => setUploadModal(false)}>
            <ModalHeader toggle={() => setUploadModal(false)}>Upload Document</ModalHeader>

            {/* <ModalBody>
              <input type="file" accept="application/pdf,image/*" onChange={handleFileChange} />
            </ModalBody> */}
            <ModalBody>
              <div className="text-center">
                {/* Hidden Input */}
                <input
                  type="file"
                  id="fileUpload"
                  accept="application/pdf,image/*"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />

                {/* ✅ Show Upload Box ONLY if no file selected */}
                {!uploadFile && (
                  <label htmlFor="fileUpload" style={{ cursor: "pointer" }}>
                    <div
                      style={{
                        border: "2px dashed #ccc",
                        padding: "30px",
                        borderRadius: "10px",
                      }}
                    >
                      <div style={{ fontSize: "40px", marginBottom: "10px" }}>📤</div>
                      <p style={{ margin: 0, fontWeight: "500" }}>Upload your document</p>
                      <small className="text-muted">Only PDF and Images allowed</small>
                    </div>
                  </label>
                )}

                {/* ✅ Show Selected File AFTER upload */}
                {uploadFile && (
                  <>
                    <p className="mt-2 ">Selected: {uploadFile.name}</p>

                    {/* Optional: Change File Button */}
                    <label htmlFor="fileUpload" style={{ cursor: "pointer" }}>
                      {/* <p className="text-primary mt-1">Change File</p> */}
                    </label>
                  </>
                )}
              </div>
            </ModalBody>

            <ModalFooter>
              <Button color="primary" onClick={handleUploadReport} disabled={uploading}>
                {uploading ? "Uploading..." : "Save"}
              </Button>
              <Button color="secondary" onClick={() => setUploadModal(false)} disabled={uploading}>
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </DataTableBody>
        {noPagination ? null : (
          <PreviewAltCard>
            {data?.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={limit}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Test found</span>
              </div>
            )}
          </PreviewAltCard>
        )}
      </DataTable>

      {/* <Card className="card-full">
        <div className="card-inner">
          <div className="card-title-group">
            <div className="card-title">
              <h6 className="title">Recent Orders</h6>
            </div>
          </div>
        </div>
        <div className="nk-tb-list mt-n2">
          <DataTableHead>
            <DataTableRow>
              <span>Order No.</span>
            </DataTableRow>
            <DataTableRow size="sm">
              <span>Customer</span>
            </DataTableRow>
            <DataTableRow size="md">
              <span>Date</span>
            </DataTableRow>
            <DataTableRow>
              <span>Amount</span>
            </DataTableRow>
            <DataTableRow>
              <span>Delivery Address</span>
            </DataTableRow>
            <DataTableRow>
              <span className=" ">Status</span>
            </DataTableRow>
            <DataTableRow>
              <span className="">Delivery Status</span>
            </DataTableRow>
          </DataTableHead>
          {isLoading ? (
            <MyLoader />
          ) : (
            <>
              {data?.length > 0 ? (
                data.map((item, idx) => (
                  <DataTableItem key={idx}>
                    <DataTableRow>
                      <span className="tb-lead">
                        <a href="#order" onClick={(ev) => ev.preventDefault()}>
                          {item.orderNum}
                        </a>
                      </span>
                    </DataTableRow>
                    <DataTableRow size="sm">
                      <div className="user-card">
                        <UserAvatar
                          className="sm"
                          theme={item.theme}
                          text={item.initial}
                          image={BASE_URL_IMG + item.user?.image}
                        ></UserAvatar>
                        <div className="user-name">
                          <span className="tb-lead">{item?.user?.name}</span>
                        </div>
                      </div>
                    </DataTableRow>
                    <DataTableRow size="md">
                      <span className="tb-sub">{item.date}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span className="tb-sub tb-amount">
                        {RUPEES_SYMBOL} {item.totalAmount}
                      </span>
                    </DataTableRow>
                    <DataTableRow size="md">
                      <span className="tb-sub">{item.address}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <Badge
                        className="badge-dot badge-dot-xs text-capitalize"
                        color={item.status === "paid" ? "success" : item.status === "due" ? "warning" : "danger"}
                      >
                        {item.status}
                      </Badge>
                    </DataTableRow>
                    <DataTableRow>
                      <Badge
                        className="badge-dot badge-dot-xs text-capitalize"
                        color={item.status === "paid" ? "success" : item.status === "due" ? "warning" : "danger"}
                      >
                        {item.status}
                      </Badge>
                    </DataTableRow>
                  </DataTableItem>
                ))
              ) : (
                <DataTableItem className="text-center">
                  <span>{"No orders found"}</span>
                </DataTableItem>
              )}
              {data?.length > 0 ? (
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={limit}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              ) : null}
            </>
          )}
        </div>
      </Card> */}

      {/* <Modal isOpen={isOpen} toggle={handleClose} centered>
        <ModalHeader toggle={handleClose}>Order</ModalHeader>

        <ModalBody>
          <p className="mb-0">
            Are you sure you want to update the order status of{" "}
            <strong>Order #{selectedRow?.orderNum || selectedRow?.order_no} </strong> to{" "}
            <strong>
              {selectedRow?.status === "processing" && "Shipped"}
              {selectedRow?.status === "shipped" && "Out for Delivery"}
              {selectedRow?.status === "out_for_delivery" && "Delivered"}
            </strong>{" "}
            placed by <strong>{selectedRow?.user?.name || selectedRow?.address?.full_name}</strong>?
          </p>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            No
          </Button>

          <Button color="danger" onClick={handleSampleStatusUpdate}>
            Yes, Update Sample Status
          </Button>
        </ModalFooter>
      </Modal> */}

      <Modal isOpen={isOpen} toggle={handleClose} centered>
        <ModalHeader toggle={handleClose}>Order</ModalHeader>

        <ModalBody>
          <p className="mb-0">
            Are you sure you want to update the sample status of{" "}
            <strong>Order #{selectedRow?.orderNum || selectedRow?.order_no} </strong> to{" "}
            <strong>
              {selectedRow?.next_status || "Unknown Status"}

              {/* {selectedRow?.status === "processin" && "Shipped"}
  {selectedRow?.status === "shipped" && "Out for Delivery"}
  {selectedRow?.status === "out_for_delivery" && "Delivered"} */}
            </strong>{" "}
            placed by <strong>{selectedRow?.user?.name || selectedRow?.address?.full_name}</strong>?
          </p>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" onClick={handleClose}>
            No
          </Button>

          <Button color="danger" onClick={handleSampleStatusUpdate}>
            Yes, Update Sample Status
          </Button>
        </ModalFooter>
      </Modal>
      <AssignOrderModal
        isOpen={assignModal}
        toggle={handleAssignModalClose}
        selectedRow={selectedRow}
        users={availableUsers}
        // onAssign={handleAssignOrder}
        onAssign={handleAssignOrderUpdate}
      />
    </>
  );
};
export default LabOrderData;
